
class FloorRoute {
  constructor(floorIndex) {
    this.FloorIndex = floorIndex;
    this.RouteLine = [];
    this.StartIcon = '';
    this.EndIcon = '';
    this.Msg = 'Default message';
  }
}
module.exports = FloorRoute;
